import Enum from '@/modules/core/app/helpers/Enum';
import Lang from '@/modules/core/app/services/Lang';
import { LawyerStatusKey } from '@/modules/lawyer/constants/LawyerStatusKey';

export class LawyerStatus extends Enum {
  key!: LawyerStatusKey;
  value!: string;
  color!: string;

  static NOT_STARTED: LawyerStatus = {
    key: LawyerStatusKey.NOT_STARTED,
    get value(): string {
      return Lang.t('lawyer.status.not_started');
    },
    color: '#ff7003'
  };

  static MEETING_BOOKED: LawyerStatus = {
    key: LawyerStatusKey.MEETING_BOOKED,
    get value(): string {
      return Lang.t('lawyer.status.meeting_booked');
    },
    color: '#0231e8'
  };

  static COMPLETED: LawyerStatus = {
    key: LawyerStatusKey.COMPLETED,
    get value(): string {
      return Lang.t('estate.completed-status');
    },
    color: '#19ca8f'
  };
}